import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Project from 'src/app/interfaces/project';
import { DealTermsService } from './deal-terms.service';
import { Subscription } from 'rxjs';
import DealTerm from 'src/app/interfaces/deal-term';
import { UpdateDealTermInput } from './graphql/deal-terms';
import Permission from 'src/app/interfaces/permission';

@Component({
    selector: 'deal-terms',
    templateUrl: './deal-terms.component.html',
    styleUrls: ['./deal-terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealTermsComponent {
  @Input() readOnly: boolean | null = null;
  @Input() hideTitle: boolean = false;
  @Input() projectId: string | null = null;

  public project: Project | null = null;
  public terms: DealTerm | null = null;
  public permissions: Permission | null = null;
  public projectSub: Subscription;
  public permissionsSub: Subscription;
  public termSub: Subscription;
  constructor(
    public route: ActivatedRoute,
    public dealTermService: DealTermsService
  ) {}
  ngOnInit() {
    if (!this.projectId) {
      this.projectId = this.route.snapshot.paramMap.get('id');
    }
    if (this.projectId)
      this.dealTermService.getProjectWithTerms(this.projectId);
    this.projectSub = this.dealTermService.project$.subscribe((project) => {
      this.project = project;
    });
    if (this.readOnly === null) {
      this.permissionsSub = this.dealTermService.permissions$.subscribe(
        (permissions) => {
          this.permissions = permissions;
          this.readOnly = !permissions?._edit;
        }
      );
    }
    this.termSub = this.dealTermService.terms$.subscribe((terms) => {
      if (terms) this.terms = structuredClone(terms);
    });
  }
  saveTerms() {
    if (this.terms) {
      let id = this.terms.id;
      let input: UpdateDealTermInput | null = this.filterForInput();
      if (id && input) {
        this.dealTermService.saveTerm(id, input);
      }
    }
  }
  filterForInput(): UpdateDealTermInput | null {
    if (this.terms) {
      let {
        credit_delivery_end,
        year_15_end,
        residual_split,
        non_profit_rofr,
        non_profit_start,
        non_profit_end,
        year_11_ilp_put_option,
        year_11_ilp_start,
        year_11_ilp_end,
        year_15_ilp_put_option,
        year_15_ilp_start,
        year_15_ilp_end,
        year_11_gp_call_option,
        year_15_gp_call_option,
        year_15_gp_put_option,
        has_exit_taxes_waterfall,
        has_exit_taxes_gp_call,
        gp_prep_fee_pct,
        prep_fee_type,
        year_11_gp_call_months,
        year_15_gp_call_months,
      } = this.terms;

      let input: UpdateDealTermInput = {
        credit_delivery_end: credit_delivery_end?.length
          ? credit_delivery_end
          : null,
        year_15_end: year_15_end?.length ? year_15_end : null,
        residual_split:
          residual_split && residual_split > 0 ? residual_split : null,
        non_profit_rofr,
        non_profit_start: non_profit_start?.length ? non_profit_start : null,
        non_profit_end: non_profit_end?.length ? non_profit_end : null,
        year_11_ilp_put_option: year_11_ilp_put_option?.length
          ? year_11_ilp_put_option
          : null,
        year_11_ilp_start: year_11_ilp_start?.length ? year_11_ilp_start : null,
        year_11_ilp_end: year_11_ilp_end?.length ? year_11_ilp_end : null,
        year_15_ilp_put_option: year_15_ilp_put_option?.length
          ? year_15_ilp_put_option
          : null,
        year_15_ilp_start: year_15_ilp_start?.length ? year_15_ilp_start : null,
        year_15_ilp_end: year_15_ilp_end?.length ? year_15_ilp_end : null,
        year_11_gp_call_option: year_11_gp_call_option?.length
          ? year_11_gp_call_option
          : null,
        year_15_gp_call_option: year_15_gp_call_option?.length
          ? year_15_gp_call_option
          : null,
        year_11_gp_call_months: year_11_gp_call_months ?? null,
        year_15_gp_call_months: year_15_gp_call_months ?? null,
        has_exit_taxes_waterfall,
        has_exit_taxes_gp_call,
        gp_prep_fee_pct,
        prep_fee_type
      };
      return input;
    }
    return null;
  }
}
